
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSettingsUserProposal as ObiSettingsUserProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-settings-user-proposal.js';
 
 
 

 
 export const ObiSettingsUserProposal = createComponent({
   react: React,
   tagName: 'obi-settings-user-proposal',
   elementClass: ObiSettingsUserProposalElement,
   events: {
     
   }
  });
 
 